import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPeugeotComponent } from './simple-icons-peugeot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPeugeotComponent ],
    exports:      [ SimpleIconsPeugeotComponent ],
    bootstrap:    []
})
export class SimpleIconsPeugeotModule {}
